import { styled } from "styled-components";

export const StyledStrongText = styled.span`
    font-weight: 700;
`;
